import { Action, Uri } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { performAction } from 'shared/queries/perform_action'
import keys from './shared/keys'

type Variables = Action

export function usePerformUserProfileAction(uri: Uri) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: mutateUser,
    onSuccess: async data => {
      return client.invalidateQueries({ queryKey: keys.all })
    },
  })

  async function mutateUser(action: Variables) {
    return performAction(server, action)
  }
}
